export default {
  discount_types: {
    cashback: 'Loyalty Punkte',
    promo_code: 'Rabatt Code',
  },
  input: {
    label: '{{cashbackLabel}} oder {{promoCodeLabel}}',
    placeholder: 'Promo Code',
  },
  buttons: {
    apply: 'Anwenden',
    remove: 'Entfernen',
  },
  feedback: {
    login:
      '<highlight>Log dich ein,</highlight> um diese Promo zu nutzen, damit wir sicherstellen, dass du sie noch nicht aufgebraucht hast. Login und versuche es erneut.',
    usage_threshold: 'Mindestbestellwert für diese Promo beträgt (abz. Lieferkosten & Trinkgeld)',
  },
};
